import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Lottie from "lottie-react";
import NotFoundAnimation from "../../../assets/oops.json";

export default function NotFound404() {
  const navigate = useNavigate();
  const currentUrl = typeof window !== "undefined" ? window.location.href : "";

  const copyUrl = async () => {
    try {
      if (navigator?.clipboard && currentUrl) {
        await navigator.clipboard.writeText(currentUrl);
      }
    } catch (e) {
      // no-op if clipboard not available
    }
  };

  const handleGoHome = () => {
    navigate("/");
  };

  const handleGoBack = () => {
    if (window?.history?.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <div
      className="min-h-screen flex flex-col font-montserrat"
      data-testid="not-found"
    >
      {/* Main Content */}
      <div className="bg-gray-50 flex-1 flex items-center justify-center px-4 py-12 animate-fade-in">
        <div className="w-full flex lg:flex-row flex-col items-center justify-center gap-3 lg:gap-0">
          {/* Left Side - Illustration */}
          <Lottie
            animationData={NotFoundAnimation}
            loop={true}
            className="lg:w-[700px] lg:h-[800px] w-[400px] h-[300px]"
          />

          {/* Right Side - Text Content */}
          <div className="flex-1 text-center lg:text-left">
            <h1 className="text-4xl lg:text-5xl font-extrabold text-gray-800 mb-8 tracking-tight">
              Page Not Found
            </h1>

            <hr className="border-gray-400 lg:w-2/3 w-full mb-8" />

            {/* Problem URL */}
            <div className=" mb-10 inline-flex items-center gap-3 max-w-full">
              <div className="flex items-center gap-2 max-w-full">
                <code
                  className="drop-shadow-lg truncate max-w-[70vw] lg:max-w-[40vw] px-3 py-2 rounded-lg bg-red-50 text-red-700 border border-red-200 font-mono text-sm"
                  title={currentUrl}
                >
                  {currentUrl || "Unavailable"}
                </code>
                <button
                  type="button"
                  onClick={copyUrl}
                  className="drop-shadow-lg px-3 py-2 rounded-md bg-gray-900 text-white-A700 text-xs font-semibold hover:bg-black hover:scale-105 transition-all duration-200"
                >
                  Copy
                </button>
              </div>
            </div>

            <p className="text-xl lg:text-xl text-gray-400">
              We couldn't find the page you are looking for.
            </p>
            <p className="text-xl lg:text-xl text-gray-400">
              The page you're trying to access doesn't exist or the URL is
              invalid.
            </p>

            {/* Go Home Button */}

            <div className="flex flex-col lg:flex-row lg:justify-start lg:items-start justify-center items-center gap-4">
              <button
                onClick={handleGoHome}
                className="mt-10 inline-flex lg:w-5/12 w-6/12 justify-center items-center gap-2 px-5 py-4 bg-green-600 text-white-A700 font-semibold rounded-2xl hover:bg-black transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
              >
                <span className="text-white-A700">Go Home</span>
              </button>
              <button
                onClick={handleGoBack}
                className="mt-0 lg:mt-10 inline-flex lg:w-3/12 w-6/12 justify-center items-center gap-2 px-5 py-4 bg-blue-600 text-white-A700 font-semibold rounded-2xl hover:bg-black transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
              >
                <ArrowLeft className="w-5 h-5" color="#FFFFFF" />
                <span className="text-white-A700">Previous Page</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
